import * as React from "react";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avtar1 from "../assets/images/avtar-1.jpg";
import Avtar2 from "../assets/images/avtar-2.jpg";
import Avtar3 from "../assets/images/avtar-3.jpg";
import ArrowRight from "../assets/images/right-arrow-white.png";
import { load } from "@amcharts/amcharts5/.internal/core/util/Net";
import Skeleton from "@mui/material/Skeleton";

const ObjectiveBox = ({ loading }) =>
  loading ? (
    <Skeleton
      variant="rectangular"
      width="100%"
      height={500}
      animation="wave"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        borderRadius: 1,
        marginBottom: 2,
      }}
    />
  ) : (
    <div className="objective-box-single">
      <span className="tag">יעוץ אובייקטיבי</span>
      <p>
        לא בטוח שאתה מבין את הנתונים? חושב שיש בעיה שצריך לטפל בה? מוזמן להתייעץ איתנו.
      </p>
      <div className="avatar-group-wrapper d-flex align-items-center justify-content-center">
        <div className="next-button">
          <span>
            <img alt="arrow" src={ArrowRight} />
          </span>
        </div>
        <AvatarGroup max={4} className="avatar-group d-flex">
          <Avatar alt="Cindy Baker" src={Avtar3} />
          <Avatar alt="Travis Howard" src={Avtar2} />
          <Avatar alt="Remy Sharp" src={Avtar1} />
        </AvatarGroup>
      </div>
      <Button className="btn border-btn" size="medium" variant="contained">
        התייעץ עכשיו
      </Button>
    </div>
  );

export default ObjectiveBox;
